/* Ephemeral She theme scripts */
(() => {
  const ES = window.ES || { t: {}, routes: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(k, d) { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* toast + cart count */
  let toastTimer;
  function toast(msg) {
    const el = $('#es-toast'); if (!el) return;
    el.textContent = msg; el.classList.add('on');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('on'), 1800);
  }
  function setCount(n) {
    const c = $('#es-cart-count'); if (!c) return;
    c.textContent = n; c.classList.add('bump'); setTimeout(() => c.classList.remove('bump'), 220);
  }
  async function refreshCount() {
    try { const r = await fetch(ES.routes.cart, { headers: { Accept: 'application/json' } }); const j = await r.json(); setCount(j.item_count); } catch (e) {}
  }
  async function addToCart(items) {
    const r = await fetch(ES.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || ES.t.error);
    await refreshCount();
    return j;
  }

  /* sparkles */
  function spark(x, y) {
    const s = document.createElement('span');
    s.className = 'es-spark'; s.textContent = ['✦', '✧', '♥', '✿'][Math.random() * 4 | 0];
    s.style.left = x + 6 + 'px'; s.style.top = y + 6 + 'px';
    s.style.color = Math.random() < .5 ? 'var(--pink-400)' : 'var(--mint-400)';
    document.body.append(s); setTimeout(() => s.remove(), 800);
  }
  function burst(x, y) { if (reduce) return; for (let i = 0; i < 10; i++) setTimeout(() => spark(x + (Math.random() * 60 - 30), y + (Math.random() * 30 - 15)), i * 25); }
  if (ES.sparkle && !reduce) {
    let last = 0;
    document.addEventListener('pointermove', e => {
      if (e.pointerType !== 'mouse') return;
      const now = performance.now(); if (now - last < 55) return; last = now; spark(e.clientX, e.clientY);
    });
  }

  /* wishlist (per browser) */
  const wish = new Set(store.get('es-wish', []));
  function paintWish() {
    $$('[data-wish]').forEach(b => b.setAttribute('aria-pressed', wish.has(b.dataset.wish)));
    $$('[data-es-wish-count]').forEach(c => c.textContent = wish.size);
  }
  document.addEventListener('click', e => {
    const h = e.target.closest('[data-wish]'); if (!h) return;
    e.preventDefault(); e.stopPropagation();
    const k = h.dataset.wish; const on = !wish.has(k);
    on ? wish.add(k) : wish.delete(k); store.set('es-wish', [...wish]); paintWish();
    h.classList.remove('pop'); void h.offsetWidth; h.classList.add('pop');
    toast(on ? ES.t.wish : ES.t.unwish);
    if (!on) h.closest('[data-es-wishlist-grid] .es-card')?.remove();
    renderWishlistEmpty();
  });
  paintWish();


  /* money formatting (store currency) */
  function fmt(cents) {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  /* wishlist page */
  function renderWishlistEmpty() {
    const grid = $('[data-es-wishlist-grid]'), empty = $('[data-es-wishlist-empty]');
    if (grid && empty) empty.hidden = grid.children.length > 0;
  }
  async function renderWishlist() {
    const grid = $('[data-es-wishlist-grid]'), tpl = $('template[data-es-wishlist-card]');
    if (!grid || !tpl) return;
    grid.innerHTML = '';
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    for (const handle of [...wish]) {
      try {
        const r = await fetch(`${root}products/${encodeURIComponent(handle)}.js`);
        if (!r.ok) { wish.delete(handle); continue; }
        const p = await r.json();
        const card = tpl.content.firstElementChild.cloneNode(true);
        $('a.cover', card).href = p.url; $('a.cover', card).setAttribute('aria-label', p.title);
        $('[data-wish]', card).dataset.wish = handle;
        const img = $('img', card);
        if (p.featured_image) { img.src = p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=480'; img.alt = p.title; } else img.remove();
        $('h3', card).textContent = p.title;
        $('.es-price', card).textContent = fmt(p.price);
        if (!p.available) { const s = document.createElement('div'); s.className = 'es-sold'; s.innerHTML = '<span>SOLD</span>'; $('.es-img', card).append(s); }
        grid.append(card);
      } catch (e) {}
    }
    store.set('es-wish', [...wish]);
    paintWish(); renderWishlistEmpty();
  }
  renderWishlist();

  /* filters: submit on change, one dropdown open at a time */
  document.addEventListener('change', e => {
    const f = e.target.closest('[data-es-filters]'); if (!f) return;
    if (e.target.matches('select, input[type=checkbox]')) {
      [...f.elements].forEach(el => { if (el.name && el.value === '' && el.type !== 'hidden') el.disabled = true; });
      f.submit();
    }
  });
  document.addEventListener('toggle', e => {
    if (!e.target.matches || !e.target.matches('.es-filter') || !e.target.open) return;
    $$('.es-filter[open]').forEach(d => { if (d !== e.target) d.open = false; });
  }, true);
  document.addEventListener('click', e => { if (!e.target.closest('.es-filter')) $$('.es-filter[open]').forEach(d => d.open = false); });

  /* predictive search (header) */
  $$('[data-es-predictive]').forEach(form => {
    const input = $('[data-es-predictive-input]', form), pop = $('[data-es-predict-target]', form);
    let timer, ctrl;
    const close = () => { pop.hidden = true; };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(async () => {
        ctrl?.abort(); ctrl = new AbortController();
        try {
          const url = `${form.dataset.url}?q=${encodeURIComponent(q)}&resources[type]=product,query&resources[limit]=6&section_id=es-predictive-search`;
          const html = await (await fetch(url, { signal: ctrl.signal })).text();
          const d = document.createElement('div'); d.innerHTML = html;
          const res = $('[data-es-predict-results]', d);
          if (res) { pop.innerHTML = ''; pop.append(res); pop.hidden = false; } else close();
        } catch (e) {}
      }, 220);
    });
    input.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); input.blur(); } });
    document.addEventListener('click', e => { if (!form.contains(e.target)) close(); });
  });


  /* member avatar: own uploaded photo if there is one, else the chosen preset drawing */
  function avatarInto(slot, p) {
    if (p && p.avatar_url) {
      const img = document.createElement('img'); img.src = p.avatar_url; img.alt = '';
      slot.replaceChildren(img); return;
    }
    const tpl = $(`template[data-es-avatar-art="${CSS.escape((p && p.avatar) || 'girl')}"]`) || $('template[data-es-avatar-art]');
    slot.replaceChildren(...(tpl ? [tpl.content.cloneNode(true)] : []));
  }
  function paintMe(p) {
    $$('[data-es-me-avatar]').forEach(s => avatarInto(s, p));
    if (p) $$('[data-es-me-name]').forEach(n => { n.textContent = p.nickname; });
    /* home: the big picture shows the member's own avatar; the girl drawing is already the default art there */
    $$('[data-es-me-big]').forEach(box => {
      const own = p && (p.avatar_url || (p.avatar && p.avatar !== 'girl'));
      if (own) avatarInto(box, p);
      box.hidden = !own;
    });
  }
  const meKey = `es-me:${ES.customerId}`;
  let friendsFetched = 0;   // header friends dropdown: last fetch time
  if (ES.customer) paintMe(store.get(meKey, null));

  /* community: own profile + badge with unread messages and friend requests (logged-in customers only) */
  async function communityCounts() {
    if (!ES.customer || !ES.community) return;
    try {
      const r = await fetch(`${ES.community}/me`, { headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      const d = await r.json();
      const p = d.profile && { nickname: d.profile.nickname, avatar: d.profile.avatar, avatar_url: d.profile.avatar_url };
      store.set(meKey, p || null); paintMe(p);
      setCommunityCount((d.unread || 0) + (d.incoming || 0));
      friendsFetched = 0;
    } catch (e) {}
  }
  function setCommunityCount(n) {
    $$('[data-es-community-count]').forEach(c => {
      if (c.textContent !== String(n)) { c.classList.add('bump'); setTimeout(() => c.classList.remove('bump'), 220); }
      c.textContent = n; c.hidden = false; c.classList.toggle('has', n > 0);
    });
  }
  communityCounts();
  setInterval(() => { if (!document.hidden) communityCounts(); }, 30000);
  window.addEventListener('es:community-counts', communityCounts);

  /* header dropdowns: friends (unread count per friend) and wishlist; hover on desktop, tap on touch */
  const hddT = JSON.parse($('[data-es-hdd-i18n]')?.textContent || '{}');
  const hdds = $$('[data-es-hdd]');
  const productCache = new Map();
  const li = (cls, text) => { const n = document.createElement('li'); n.className = cls; n.textContent = text; return n; };

  async function fillFriends(list) {
    if (Date.now() - friendsFetched < 20000) return;
    friendsFetched = Date.now();
    let d = null, ok = false;
    try { const r = await fetch(`${ES.community}/friends`, { headers: { Accept: 'application/json' } }); ok = r.ok; d = await r.json(); } catch (e) {}
    const reqBox = $('[data-es-hdd-requests]');
    if (!ok || !d) {
      friendsFetched = 0;
      if (d && d.error === 'profile_required') {
        const a = document.createElement('a'); a.href = hddT.my_page + '#profile'; a.textContent = hddT.no_profile;
        const row = li('es-hdd-empty', ''); row.append(a); list.replaceChildren(row);
      } else list.replaceChildren(li('es-hdd-empty', hddT.unavailable));
      return;
    }
    setCommunityCount(d.friends.reduce((n, f) => n + (f.unread || 0), 0) + d.incoming.length);
    if (reqBox) {
      reqBox.hidden = !d.incoming.length;
      $('[data-es-hdd-requests-text]', reqBox).textContent = (hddT.requests || '').replace('%count%', d.incoming.length);
    }
    if (!d.friends.length) { list.replaceChildren(li('es-hdd-empty', hddT.empty_friends)); return; }
    const sorted = [...d.friends].sort((x, y) => (y.unread - x.unread) || ((y.last_at || 0) - (x.last_at || 0)));
    list.replaceChildren(...sorted.slice(0, 8).map(f => {
      const row = document.createElement('li');
      const a = document.createElement('a'); a.className = 'es-hdd-row';
      a.href = `${hddT.community}?chat=${encodeURIComponent(f.public_id)}`;
      const av = document.createElement('span'); av.className = 'es-ava'; avatarInto(av, f);
      const info = document.createElement('span'); info.className = 'es-hdd-info';
      const name = document.createElement('b'); name.textContent = f.nickname;
      const sub = document.createElement('small'); sub.textContent = f.last || f.bio || '';
      info.append(name, sub);
      a.append(av, info);
      if (f.unread) {
        const n = document.createElement('i'); n.className = 'es-hdd-count'; n.textContent = f.unread > 99 ? '99+' : f.unread;
        n.title = (hddT.unread || '').replace('%count%', f.unread);
        a.append(n);
      }
      row.append(a); return row;
    }));
  }

  async function fillWish(list) {
    const handles = [...wish].reverse();
    if (!handles.length) { list.replaceChildren(li('es-hdd-empty', list.dataset.empty)); return; }
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const rows = await Promise.all(handles.slice(0, 6).map(async h => {
      if (!productCache.has(h)) {
        try { const r = await fetch(`${root}products/${encodeURIComponent(h)}.js`); productCache.set(h, r.ok ? await r.json() : null); }
        catch (e) { return null; }
      }
      const p = productCache.get(h); if (!p) return null;
      const row = document.createElement('li');
      const a = document.createElement('a'); a.className = 'es-hdd-row'; a.href = p.url;
      const th = document.createElement('span'); th.className = 'es-hdd-thumb';
      if (p.featured_image) { const img = document.createElement('img'); img.src = p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=120'; img.alt = ''; th.append(img); }
      const info = document.createElement('span'); info.className = 'es-hdd-info';
      const name = document.createElement('b'); name.textContent = p.title;
      const price = document.createElement('small'); price.textContent = p.available ? fmt(p.price) : `${fmt(p.price)} · ${ES.t.soldout}`;
      info.append(name, price); a.append(th, info); row.append(a);
      return row;
    }));
    const found = rows.filter(Boolean);
    if (found.length) list.replaceChildren(...found);
  }

  async function fillCart(list) {
    let c;
    try { c = await (await fetch(ES.routes.cart, { headers: { Accept: 'application/json' } })).json(); } catch (e) { return; }
    const foot = $('[data-es-hdd-cartfoot]');
    setCount(c.item_count);
    if (!c.items.length) { list.replaceChildren(li('es-hdd-empty', list.dataset.empty)); if (foot) foot.hidden = true; return; }
    list.replaceChildren(...c.items.slice(0, 6).map(it => {
      const row = document.createElement('li');
      const a = document.createElement('a'); a.className = 'es-hdd-row'; a.href = it.url;
      const th = document.createElement('span'); th.className = 'es-hdd-thumb';
      if (it.image) { const img = document.createElement('img'); img.src = it.image + (it.image.includes('?') ? '&' : '?') + 'width=120'; img.alt = ''; th.append(img); }
      const info = document.createElement('span'); info.className = 'es-hdd-info';
      const name = document.createElement('b'); name.textContent = it.product_title;
      const sub = document.createElement('small');
      sub.textContent = `${it.variant_title ? it.variant_title + ' · ' : ''}× ${it.quantity}`;
      info.append(name, sub);
      const price = document.createElement('span'); price.className = 'es-hdd-price'; price.textContent = fmt(it.final_line_price);
      a.append(th, info, price); row.append(a); return row;
    }));
    if (c.items.length > 6) list.append(li('es-hdd-empty', `+ ${c.items.length - 6}`));
    if (foot) { foot.hidden = false; $('[data-es-hdd-subtotal]', foot).textContent = fmt(c.total_price); }
  }

  function openHdd(d) {
    hdds.forEach(x => { if (x !== d) { x.classList.remove('open'); $('a', x).setAttribute('aria-expanded', 'false'); } });
    d.classList.add('open'); $('a', d).setAttribute('aria-expanded', 'true');
    const pop = $('.es-hdd-pop', d);
    if (matchMedia('(max-width: 640px)').matches) pop.style.top = `${d.getBoundingClientRect().bottom + 8}px`; else pop.style.top = '';
    if (d.dataset.esHdd === 'friends') fillFriends($('[data-es-hdd-friends]', d));
    else if (d.dataset.esHdd === 'cart') fillCart($('[data-es-hdd-cart]', d));
    else fillWish($('[data-es-hdd-wish]', d));
  }
  const closeHdds = () => hdds.forEach(x => { x.classList.remove('open'); $('a', x).setAttribute('aria-expanded', 'false'); });
  hdds.forEach(d => {
    const top = $('a', d);
    let leaveTimer;
    d.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) { clearTimeout(leaveTimer); openHdd(d); } });
    d.addEventListener('mouseleave', () => { if (matchMedia('(hover: hover)').matches) leaveTimer = setTimeout(() => { d.classList.remove('open'); top.setAttribute('aria-expanded', 'false'); }, 160); });
    d.addEventListener('focusin', () => { if (!d.classList.contains('open')) openHdd(d); });
    let openAtPress = false;   // focus opens it before the click arrives, so remember the state at press time
    top.addEventListener('pointerdown', () => { openAtPress = d.classList.contains('open'); });
    top.addEventListener('click', e => {
      const touch = matchMedia('(hover: none), (max-width: 640px)').matches;
      if (!touch || openAtPress) return;   // second tap follows the link
      e.preventDefault(); openAtPress = true; openHdd(d);
    });
    d.addEventListener('keydown', e => { if (e.key === 'Escape') { closeHdds(); top.focus(); } });
  });
  document.addEventListener('click', e => { if (!e.target.closest('[data-es-hdd]')) closeHdds(); });
  document.addEventListener('focusin', e => { if (!e.target.closest('[data-es-hdd]')) closeHdds(); });
  window.addEventListener('scroll', () => { if (matchMedia('(max-width: 640px)').matches) closeHdds(); }, { passive: true });


  /* background music: the shopper switches it on once; it then follows them from page to page */
  $$('[data-es-bgm]').forEach(btn => {
    const audio = new Audio(); audio.src = btn.dataset.src; audio.loop = true; audio.preload = 'none';
    audio.volume = Math.min(1, Math.max(0.05, parseFloat(btn.dataset.volume) || 0.4));
    const st = store.get('es-bgm', { on: false, t: 0, src: '' });
    if (st.src !== btn.dataset.src) { st.t = 0; st.src = btn.dataset.src; }
    const paint = on => {
      btn.setAttribute('aria-pressed', on); btn.setAttribute('aria-label', on ? btn.dataset.labelOn : btn.dataset.labelOff);
      document.documentElement.classList.toggle('es-bgm-on', on);
    };
    const save = () => { st.t = audio.currentTime || st.t; store.set('es-bgm', st); };
    let resumed = false;   // carry on from where the previous page left off (seek only once playback has started)
    const play = async () => {
      try {
        await audio.play();
        if (!resumed) { resumed = true; if (st.t && st.t < (audio.duration || Infinity)) audio.currentTime = st.t; }
        st.on = true; paint(true); save();
      }
      catch (e) {   // browser blocked autoplay: start on the shopper's next tap or key press
        paint(false);
        const resume = () => { document.removeEventListener('pointerdown', resume, true); document.removeEventListener('keydown', resume, true); if (st.on && audio.paused) play(); };
        document.addEventListener('pointerdown', resume, true); document.addEventListener('keydown', resume, true);
      }
    };
    btn.addEventListener('click', e => {
      e.stopPropagation();
      if (audio.paused) { st.on = true; play(); } else { audio.pause(); st.on = false; paint(false); save(); }
    });
    if (st.on && !reduce) play();
    setInterval(() => { if (!audio.paused) save(); }, 2000);
    window.addEventListener('pagehide', save);
  });

  /* signed-in members who have not subscribed get asked once */
  $$('[data-es-news-ask]').forEach(m => {
    const key = m.dataset.key;
    if (store.get(key, false)) return;
    setTimeout(() => { m.hidden = false; $('[data-es-news-yes]', m)?.focus(); }, 1500);
    const done = () => { store.set(key, true); m.hidden = true; };
    $('[data-es-news-no]', m)?.addEventListener('click', done);
    $('form', m)?.addEventListener('submit', () => store.set(key, true));
    m.addEventListener('click', e => { if (e.target === m) done(); });
  });

  /* copy-to-clipboard buttons (discount codes) */
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-es-copy]'); if (!b) return;
    try { await navigator.clipboard.writeText(b.dataset.esCopy); toast(`${b.dataset.esCopy} ✓`); } catch (err) { /* code stays visible */ }
  });

  /* tea party calendar: Apple-Calendar-style month grid, hover card on desktop, bottom sheet on touch */
  $$('[data-es-calendar]').forEach(root => {
    const events = JSON.parse($('[data-cal-events]', root)?.textContent || '[]');
    const L = JSON.parse($('[data-cal-i18n]', root)?.textContent || '{}');
    const grid = $('[data-cal-grid]', root), title = $('[data-cal-title]', root);
    const pop = $('[data-cal-pop]', root), sheet = $('[data-cal-sheet]', root), sheetBody = $('[data-cal-sheet-body]', root);
    document.body.append(pop);   // positioned against the page, not the section
    const lang = document.documentElement.lang || undefined;
    const pad = n => String(n).padStart(2, '0');
    const key = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const byDay = {};
    events.forEach(ev => (byDay[ev.date] = byDay[ev.date] || []).push(ev));
    Object.values(byDay).forEach(list => list.sort((a, b) => (a.start || '').localeCompare(b.start || '')));
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const first = events.map(e => new Date(`${e.date}T00:00:00`)).filter(d => d >= today).sort((a, b) => a - b)[0];
    let view = new Date((first || today).getFullYear(), (first || today).getMonth(), 1);
    const touch = () => matchMedia('(hover: none), (max-width: 760px)').matches;

    $$('.es-tea-event', root).forEach(card => { if (new Date(`${card.dataset.date}T00:00:00`) < today) card.classList.add('past'); });

    // detail card (DOM built with textContent; description is the store's own rich text)
    function detail(ev) {
      const box = document.createElement('div'); box.className = 'es-cal-detail';
      if (ev.image) {
        const fig = document.createElement('div'); fig.className = 'es-tea-imgbox';
        const img = new Image(); img.src = ev.image; img.alt = ev.title; img.loading = 'lazy';
        fig.append(img); box.append(fig);
      }
      const h = document.createElement('h3'); h.textContent = ev.title; box.append(h);
      const row = (label, text, cls) => { if (!text) return; const p = document.createElement('p'); p.className = cls || 'es-cal-row'; const i = document.createElement('i'); i.textContent = label; p.append(i, ' ', text); box.append(p); };
      row(L.theme, ev.theme, 'es-tea-theme');
      row(L.when, ev.dateLabel);
      row(L.time, ev.start ? ev.start + (ev.end ? ` – ${ev.end}` : '') : '');
      row(L.where, ev.place);
      row(L.dress, ev.dress);
      if (ev.desc) { const d = document.createElement('div'); d.className = 'es-rte'; d.innerHTML = ev.desc; box.append(d); }
      const actions = document.createElement('div'); actions.className = 'es-cal-actions';
      if (ev.url) { const a = document.createElement('a'); a.className = 'es-btn solid'; a.href = ev.url; a.textContent = L.join; actions.append(a); }
      const more = document.createElement('a'); more.className = 'es-linkbtn'; more.href = `#${ev.id}`; more.textContent = L.more;
      more.addEventListener('click', () => { closeSheet(); hidePop(true); });
      actions.append(more); box.append(actions);
      return box;
    }

    // hover card
    let hideTimer;
    function showPop(ev, anchor) {
      clearTimeout(hideTimer);
      pop.replaceChildren(detail(ev)); pop.hidden = false;
      const place = () => {
        const r = anchor.getBoundingClientRect(), pw = pop.offsetWidth, ph = pop.offsetHeight;
        let left = r.right + 10, top = r.top - 10;
        if (left + pw > innerWidth - 12) left = r.left - pw - 10;
        if (left < 12) left = Math.max(12, Math.min(innerWidth - pw - 12, r.left));
        if (top + ph > innerHeight - 12) top = Math.max(12, innerHeight - ph - 12);
        pop.style.left = `${left + scrollX}px`; pop.style.top = `${top + scrollY}px`;
      };
      place();
      const img = $('img', pop); if (img && !img.complete) img.addEventListener('load', place, { once: true });
    }
    function hidePop(now) { clearTimeout(hideTimer); hideTimer = setTimeout(() => { pop.hidden = true; }, now ? 0 : 180); }
    pop.addEventListener('mouseenter', () => clearTimeout(hideTimer));
    pop.addEventListener('mouseleave', () => hidePop());

    // sheet (touch / small screens)
    function openSheet(list) {
      sheetBody.replaceChildren(...list.map(detail));
      sheet.hidden = false; document.body.classList.add('es-noscroll');
      $('[data-cal-sheet-close]', root).focus();
    }
    function closeSheet() { sheet.hidden = true; document.body.classList.remove('es-noscroll'); }
    $('[data-cal-sheet-close]', root).addEventListener('click', closeSheet);
    sheet.addEventListener('click', e => { if (e.target === sheet) closeSheet(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeSheet(); hidePop(true); } });

    function render() {
      title.textContent = view.toLocaleDateString(lang, { month: 'long', year: 'numeric' });
      grid.replaceChildren();
      for (let i = 0; i < 7; i++) {
        const h = document.createElement('div'); h.className = 'es-cal-wd';
        h.textContent = new Date(2024, 0, 1 + i).toLocaleDateString(lang, { weekday: 'short' }); // 2024-01-01 is a Monday
        grid.append(h);
      }
      const offset = (view.getDay() + 6) % 7;
      const start = new Date(view.getFullYear(), view.getMonth(), 1 - offset);
      const daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      const cells = Math.ceil((offset + daysInMonth) / 7) * 7;
      for (let i = 0; i < cells; i++) {
        const d = new Date(start.getFullYear(), start.getMonth(), start.getDate() + i), k = key(d), evs = byDay[k] || [];
        const cell = document.createElement('div');
        cell.className = 'es-cal-cell' + (d.getMonth() !== view.getMonth() ? ' other' : '') + (+d === +today ? ' today' : '') + (d < today ? ' past' : '') + (evs.length ? ' has' : '');
        const num = document.createElement('span'); num.className = 'es-cal-num'; num.textContent = d.getDate();
        cell.append(num);
        evs.forEach(ev => {
          const chip = document.createElement('button'); chip.type = 'button'; chip.className = 'es-cal-ev';
          if (ev.start) { const t = document.createElement('b'); t.textContent = ev.start; chip.append(t); }
          chip.append(document.createTextNode(ev.title));
          chip.setAttribute('aria-label', `${ev.title}, ${ev.dateLabel}${ev.start ? ', ' + ev.start : ''}`);
          chip.addEventListener('mouseenter', () => { if (!touch()) showPop(ev, chip); });
          chip.addEventListener('mouseleave', () => { if (!touch()) hidePop(); });
          chip.addEventListener('focus', () => { if (!touch()) showPop(ev, chip); });
          chip.addEventListener('blur', () => { if (!touch()) hidePop(); });
          chip.addEventListener('click', e => { e.stopPropagation(); if (touch()) openSheet([ev]); else showPop(ev, chip); });
          cell.append(chip);
        });
        if (evs.length) cell.addEventListener('click', () => { if (touch()) openSheet(evs); });
        grid.append(cell);
      }
    }
    $('[data-cal-prev]', root).addEventListener('click', () => { view = new Date(view.getFullYear(), view.getMonth() - 1, 1); render(); });
    $('[data-cal-next]', root).addEventListener('click', () => { view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render(); });
    $('[data-cal-today]', root).addEventListener('click', () => { view = new Date(today.getFullYear(), today.getMonth(), 1); render(); });
    render();
  });

  /* main menu dropdowns: hover on desktop (CSS), tap to open on touch / small screens */
  const subs = $$('[data-es-sub]');
  const closeSubs = except => subs.forEach(li => { if (li !== except) { li.classList.remove('open'); $('a', li).setAttribute('aria-expanded', 'false'); } });
  subs.forEach(li => {
    const top = $('a', li);
    top.addEventListener('click', e => {
      const touch = matchMedia('(hover: none), (max-width: 640px)').matches;
      if (!touch || li.classList.contains('open')) return;   // second tap follows the link
      e.preventDefault();
      closeSubs(li);
      li.classList.add('open'); top.setAttribute('aria-expanded', 'true');
      const sheet = $('.es-subnav', li);
      if (matchMedia('(max-width: 640px)').matches) sheet.style.top = `${li.getBoundingClientRect().bottom + 8}px`;
    });
    li.addEventListener('keydown', e => { if (e.key === 'Escape') { closeSubs(); top.focus(); } });
  });
  document.addEventListener('click', e => { if (!e.target.closest('[data-es-sub]')) closeSubs(); });
  window.addEventListener('scroll', () => closeSubs(), { passive: true });

  /* All / New In / Second Hand switch above product grids */
  $$('[data-es-typeswitch]').forEach(sw => {
    const grid = sw.parentElement.querySelector('[data-es-typegrid]');
    if (!grid) return;
    const cards = $$('[data-type]', grid);
    const types = new Set(cards.map(c => c.dataset.type));
    if (types.size < 2) return;           // nothing to switch between
    sw.hidden = false;
    sw.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      $$('button', sw).forEach(x => x.setAttribute('aria-pressed', x === b));
      cards.forEach(c => c.classList.toggle('is-hidden', b.dataset.type !== 'all' && c.dataset.type !== b.dataset.type));
    });
  });

  /* modals */
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-es-open]');
    if (o) { const m = document.getElementById(o.dataset.esOpen); if (m) { m.hidden = false; $('[data-es-close]', m)?.focus(); } return; }
    if (e.target.closest('[data-es-close]') || e.target.classList.contains('es-modal')) {
      const m = e.target.closest('.es-modal'); if (m) m.hidden = true;
    }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') $$('.es-modal').forEach(m => m.hidden = true); });

  /* sections (re-run when the theme editor reloads a section) */
  function initSection(scope) {
  /* home: messages read state */
  const read = new Set(store.get('es-read', []));
  $$('[data-msg]', scope).forEach(a => {
    if (read.has(a.dataset.msg)) a.classList.add('read');
    a.addEventListener('click', () => { read.add(a.dataset.msg); store.set('es-read', [...read]); });
  });

  /* home: carousel (one-at-a-time on phones, highlight cycling on desktop) */
  $$('[data-es-carousel]', scope).forEach(hero => {
    const slides = $$('.es-slide', hero); if (slides.length < 2) return;
    const dots = $$('button', hero.parentElement.querySelector('[data-es-dots]') || document.createElement('div'));
    let i = 0, timer;
    const show = n => { i = (n + slides.length) % slides.length; slides.forEach((s, k) => s.classList.toggle('on', k === i)); dots.forEach((d, k) => d.setAttribute('aria-current', k === i)); };
    dots.forEach((d, k) => d.addEventListener('click', () => { show(k); start(); }));
    const start = () => { clearInterval(timer); if (!reduce) timer = setInterval(() => show(i + 1), 4500); };
    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', start);
    start();
  });

  /* story toggle */
  $$('[data-es-story]', scope).forEach(s => {
    const b = $('button', s);
    b.addEventListener('click', () => { const o = s.dataset.open !== 'true'; s.dataset.open = o; b.setAttribute('aria-expanded', o); });
  });

  /* product page */
  $$('[data-es-product]', scope).forEach(root => {
    const medias = $$('.es-media', root), thumbs = $$('.es-thumb', root);
    const pager = $('[data-es-pager]', root), figure = $('[data-es-figure]', root), stage = $('[data-es-stage]', root);
    let mi = 0, bg = 0;
    const showMedia = n => {
      if (!medias.length) return;
      mi = (n + medias.length) % medias.length;
      medias.forEach((m, k) => m.hidden = k !== mi);
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === mi));
      if (pager) pager.textContent = `${mi + 1} / ${medias.length}`;
      figure.classList.remove('zoom');
    };
    thumbs.forEach(t => t.addEventListener('click', () => showMedia(+t.dataset.mediaIndex)));
    $('[data-es-prev]', root)?.addEventListener('click', () => showMedia(mi - 1));
    $('[data-es-next]', root)?.addEventListener('click', () => showMedia(mi + 1));
    $('[data-es-pose]', root)?.addEventListener('click', () => { bg = (bg + 1) % 3; stage.className = 'es-stage bg' + bg; });
    figure?.addEventListener('click', e => { if (!e.target.closest('video,model-viewer')) figure.classList.toggle('zoom'); });

    /* variants */
    const variants = JSON.parse($('[data-es-variants]', root)?.textContent || '[]');
    const form = $('#es-product-form', root);
    const idInput = $('[data-es-variant-id]', root);
    const priceEl = $('[data-es-price]', root);
    const addBtn = $('[data-es-add]', root), addLabel = $('[data-es-add-label]', root);
    const meas = $('[data-es-meas]', root);
    const sync = () => {
      const opts = $$('[data-es-option]', root).map(fs => ($('input:checked', fs) || {}).value);
      const v = variants.find(v => v.options.every((o, k) => o === opts[k]));
      $$('[data-es-option]', root).forEach((fs, idx) => {
        $$('input', fs).forEach(inp => {
          const test = opts.slice(); test[idx] = inp.value;
          const ok = variants.some(v => v.available && v.options.every((o, k) => o === test[k]));
          inp.nextElementSibling.classList.toggle('unavail', !ok);
        });
      });
      if (meas) $$('tbody tr', meas).forEach(tr => tr.style.background = opts.includes(tr.dataset.size) ? 'var(--mint-50)' : '');
      if (!v) { addBtn.disabled = true; addLabel.textContent = ES.t.soldout; return; }
      idInput.value = v.id;
      priceEl.innerHTML = fmt(v.price) + (v.compare_at_price > v.price ? `<s>${fmt(v.compare_at_price)}</s>` : '');
      addBtn.disabled = !v.available; addLabel.textContent = v.available ? ES.t.add : ES.t.soldout;
      if (v.featured_media) { const k = medias.findIndex(m => m.dataset.mediaId == v.featured_media.id); if (k > -1) showMedia(k); }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('[data-es-option] input', root).forEach(i => i.addEventListener('change', sync));
    if (variants.length > 1) sync();

    /* quantity */
    const q = $('input[name="quantity"]', root);
    $$('[data-es-qty]', root).forEach(b => b.addEventListener('click', () => {
      const max = +q.max || 99; q.value = Math.min(max, Math.max(1, (+q.value || 1) + +b.dataset.esQty));
    }));

    /* add to cart */
    form?.addEventListener('submit', async e => {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.disabled = true;
      try {
        await addToCart([{ id: +idInput.value, quantity: +q.value || 1 }]);
        toast(ES.t.added);
        const r = addBtn.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2);
      } catch (err) { toast(err.message); }
      addBtn.disabled = false;
    });

    /* complete your look */
    const recs = $('[data-es-recs]', root);
    if (recs) {
      const target = $('[data-es-recs-target]', recs);
      const load = async url => { const r = await fetch(url); const html = await r.text(); const d = document.createElement('div'); d.innerHTML = html; return d.querySelector('.shopify-section')?.innerHTML.trim() || ''; };
      (async () => {
        try {
          let html = await load(recs.dataset.url);
          if (!html.includes('es-lk')) html = await load(recs.dataset.fallbackUrl);
          if (html.includes('es-lk')) target.innerHTML = html; else recs.hidden = true;
        } catch (e) { recs.hidden = true; }
      })();
      recs.addEventListener('click', async e => {
        const b = e.target.closest('[data-es-quick-add]'); if (!b) return;
        e.preventDefault();
        try { await addToCart([{ id: +b.dataset.esQuickAdd, quantity: 1 }]); b.closest('.es-lk').classList.add('added'); b.textContent = '✓'; toast(ES.t.added); }
        catch (err) { toast(err.message); }
      });
    }
  });
  }
  initSection(document);
  document.addEventListener('shopify:section:load', e => { initSection(e.target); paintWish(); });

  /* countdowns */
  {
    const monthEnd = () => { const n = new Date(); return new Date(n.getFullYear(), n.getMonth() + 1, 1).getTime() - 1000; };
    const tick = () => $$('[data-countdown]').forEach(cd => {
      const end = 'countdownMonthEnd' in cd.dataset ? monthEnd() : Date.parse((cd.dataset.countdown || '').trim().replace(' ', 'T').replace(/([+-]\d{2})(\d{2})$/, '$1:$2')); if (isNaN(end)) return;
      let d = Math.max(0, end - Date.now()) / 1000;
      const v = { d: Math.floor(d / 86400) };
      d %= 86400; v.h = Math.floor(d / 3600); d %= 3600; v.m = Math.floor(d / 60); v.s = Math.floor(d % 60);
      $$('[data-u]', cd).forEach(b => b.textContent = String(v[b.dataset.u]).padStart(2, '0'));
    });
    tick(); setInterval(tick, 1000);
  }

})();
